if (!customElements.get('infinite-scroll')) {
  customElements.define(
    'infinite-scroll',
    class InfiniteScroll extends HTMLElement {
      constructor() {
        super();
        this.loading = false;
        this.observer = null;
      }

      connectedCallback() {
        this.nextUrl = this.dataset.nextUrl;
        this.sectionId = this.dataset.sectionId;
        this.spinner = this.querySelector('.infinite-scroll__spinner');

        const paginationWrapper = this.previousElementSibling;
        if (paginationWrapper && paginationWrapper.classList.contains('pagination-wrapper')) {
          paginationWrapper.hidden = true;
        }

        if (!this.nextUrl) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries[0].isIntersecting) this.loadNextPage();
          },
          { rootMargin: '600px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      loadNextPage() {
        if (!this.nextUrl || this.loading) return;
        this.loading = true;
        if (this.spinner) this.spinner.classList.add('is-visible');

        const separator = this.nextUrl.includes('?') ? '&' : '?';
        const url = `${this.nextUrl}${separator}section_id=${this.sectionId}`;

        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const newItems = html.querySelectorAll('#product-grid .grid__item');
            const grid = document.getElementById('product-grid');

            if (grid) {
              newItems.forEach((item) => grid.appendChild(item));
            }

            const nextInfiniteScroll = html.querySelector('infinite-scroll');
            this.nextUrl = nextInfiniteScroll ? nextInfiniteScroll.dataset.nextUrl : '';

            if (!this.nextUrl && this.observer) {
              this.observer.disconnect();
            }
          })
          .catch(() => {
            if (this.observer) this.observer.disconnect();
          })
          .finally(() => {
            this.loading = false;
            if (this.spinner) this.spinner.classList.remove('is-visible');
          });
      }
    }
  );
}
